// const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
// const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
// const connectedDevice = sessionStorage.getItem('connectedDevice')

var socketInitialState = {
    socket: null,
    isAgentConnected: false, // Add this
}

const socketReducer = (state = socketInitialState, action) => {
    switch (action.type) {
        case 'SOCKET': {
            console.log('SOCKET INITIALIZED', action.payload)
            return {
                ...state,
                socket: action.payload,
            }
        }
        case 'SOCKET_STATUS': {
            console.log('SOCKET STATUS CHANGE:', action.payload)
            return {
                ...state,
                isAgentConnected: action.payload,
            }
        }
        default:
            return state
    }
}

export default socketReducer
